import React from 'react';
import '../../styles/SolucionesPublicitarias.css';
import {
  FaArrowRight,
  FaArrowDown,
  FaArrowUp,
  FaArrowLeft
} from 'react-icons/fa';

const BeAds = () => {
  return (
    <section className="be-ads-section py-5">
      <div className="container">
        {/* Primera fila: Display y Video */}
        <div className='row align-items-center'>
          <div className='col-md-6 col-lg-6'>
            <div className="title-container" data-aos="fade-up">
              <h2 className="title">Be <span>Ads</span></h2>
              <div className="title-underline"></div>


              <div className="section-description pb-0 mb-0" data-aos="fade-up">
                <p className='pb-0 mb-0'>
                  <span className='description-highlight'>Ofrecemos diversas herramientas y formatos publicitarios</span> que potencian tu estrategia, permitiéndote
                  diversificar el mensaje y amplificar el impacto en el público de tu interés.
                </p>
              </div>
            </div>
          </div>
          <div className='col-md-6 col-lg-6'>
            <div className="row justify-content-center align-items-center">
              <div className="col-6 mb-4 position-relative z-4" data-aos="zoom-in-right" data-aos-delay="100" data-original-delay="100">
                <div className="card-custom display">
                  <h4 className="fw-bold">Display</h4>
                  <img src="assets/be_ads_1.png" className="card-icon img-fluid" alt='display'/>
                  <p>Visibilidad</p>
                  <FaArrowRight className="arrow arrow-right" />
                </div>
              </div>
              <div className="col-6 mb-4 position-relative z-3" data-aos="zoom-in-left" data-aos-delay="300" data-original-delay="300">
                <div className="card-custom video">
                  <h4 className="fw-bold">Video</h4>
                  <img src="assets/be_ads_2.png" className="card-icon img-fluid" alt='video'/>
                  <p>Atención</p>
                  <FaArrowDown className="arrow arrow-down" />
                </div>
              </div>
            </div>

            {/* Segunda fila: Micrositios y Contenido */}
            <div className="row justify-content-center align-items-center ">
              <div className="col-6 mb-4 position-relative z-3" data-aos="zoom-in-right" data-aos-delay="500" data-original-delay="500">
                <div className="card-custom micrositios">
                  <h4 className="fw-bold">Micrositios</h4>
                  <img src="assets/be_ads_3.png" className="card-icon img-fluid" alt='micrositios'/>
                  <p>Conversión</p>
                  <FaArrowUp className="arrow arrow-up" />
                </div>
              </div>
              <div className="col-6 mb-4 position-relative z-3" data-aos="zoom-in-left" data-aos-delay="700" data-original-delay="700">
                <div className="card-custom contenido">
                  <h4 className="fw-bold">Contenido</h4>
                  <img src="assets/be_ads_4.png" className="card-icon img-fluid" alt='contenidos'/>
                  <p>Interacción</p>
                  <FaArrowLeft className="arrow arrow-left" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BeAds;

